import { QBox, QIconButton, QStack, QTooltip } from '@qualio/ui-components';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentOverviewContext } from '../Context';
import styles from './QMultiRootEditor.module.css';

type CommentButtonsProps = {
  id: 'documentCommentControl' | 'changeControlCommentControl';
};
export const CommentButtons = ({ id }: CommentButtonsProps) => {
  const { t } = useTranslation();
  const { commentsPermission } = useContext(DocumentOverviewContext);

  if (commentsPermission < 2) {
    return null;
  }

  return (
    <QBox
      px={2}
      py={4}
      id={id}
      data-cy={id}
      className={`${styles['document-comment-control']}`}
    >
      <QStack
        direction="column"
        spacing={1}
        background="white"
        borderRadius="lg"
        p={2}
        id={'commentButtonsContainer'}
      >
        <QTooltip
          label={t('tooltips.selectContentToAddComment')}
          placement={'top'}
        >
          <QIconButton
            iconName={'MessageSquare'}
            aria-label="icon-button"
            size="sm"
            data-cy="comment-button"
          />
        </QTooltip>
        <QTooltip label={t('tooltips.openCommentHistory')} placement={'top'}>
          <QIconButton
            iconName={'MessageCheck'}
            aria-label="icon-button"
            size="sm"
            data-cy="comment-history-button"
          />
        </QTooltip>
      </QStack>
    </QBox>
  );
};
